import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d751fcf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg text-center text-textPrimary" }, "Aplicar Filtros", -1))
const _hoisted_2 = { class: "flex flex-col md:flex-row flex-1 min-h-0" }
const _hoisted_3 = { class: "shrink-0 flex flex-row md:flex-col md:w-[260px] bg-[#F0F0F4] border-b md:border-b-0 md:border-r border-[#D8D8E2] overflow-x-auto md:overflow-x-visible" }
const _hoisted_4 = ["data-testid", "onClick"]
const _hoisted_5 = { class: "text-xs md:text-base leading-6 whitespace-nowrap" }
const _hoisted_6 = { class: "flex-1 flex flex-col min-w-0" }
const _hoisted_7 = { class: "flex-1 overflow-y-auto p-4 md:p-6" }
const _hoisted_8 = { class: "font-bold text-xl leading-6 text-[#323232] mb-6 text-left" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" }
const _hoisted_10 = { class: "md:col-span-2" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" }
const _hoisted_14 = { class: "shrink-0 px-4 md:px-6 pb-4 md:pb-6 pt-2" }
const _hoisted_15 = { class: "flex gap-4 md:gap-6 w-full" }

import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { filterStates, useFilterStationsStore } from './useFilterStation'
import MultipleSchedules from '@/components/Autocompletes/MultipleSchedules.vue'
import {
  mdiCalendar,
  mdiInformationOutline,
  mdiCalendarClock,
  mdiCashMultiple,
  mdiCheckboxMarkedCircleOutline
} from '@mdi/js'
import { DatePicker } from 'v-calendar'
import { ref, computed, onUnmounted, watch } from 'vue'
import StationSectorSpecialtyFilters from './StationSectorSpecialtyFilters.vue'
import { weekDays } from '@/utils/date'
import { useOperationalGroups } from '@/hooks/useOperationalGroups'
import { useToast } from 'vue-toastification'
import CoverageStatusFilterChips from '@/components/Coverage/CoverageStatusFilterChips.vue'
import { useStationStore } from '@/pinia-store/useStationStore'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'

/**
 * O modal também serve "Aprovar plantões" (Management), cujo endpoint não filtra por setor/
 * especialidade do plantão: os selects (e o fetch dos catálogos) só existem onde a prop liga.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'filter.stations',
  props: {
    showSectorSpecialty: { type: Boolean, default: false },
    showCoverageStatus: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const tabConfig = [
  { key: 'info', label: 'Informações Principais', icon: mdiInformationOutline },
  { key: 'data', label: 'Data e Recorrência', icon: mdiCalendarClock },
  { key: 'valores', label: 'Valores e Pagamento', icon: mdiCashMultiple },
  { key: 'status', label: 'Status do Plantão', icon: mdiCheckboxMarkedCircleOutline }
]

const currentTab = ref('info')
const currentTabLabel = computed(
  () => tabConfig.find((t) => t.key === currentTab.value)?.label ?? ''
)

const modalName = EModals.FILTER_STATION
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}

const isLoading = ref(false)
// Grupos operacionais sob demanda, ao ABRIR o modal: o componente fica montado na página e
// carregar no mount viraria toast a cada visita quando o endpoint nega (ex.: 403 por papel).
// O hook guarda o cache da sessão e divide a busca em voo (um toast só).
const { options: operationalGroups, load: loadOperationalGroups } = useOperationalGroups()
const operationalGroupOptions = computed(() => operationalGroups.value.map((group) => group.value))
const tempStartHour = ref(undefined)
const tempEndHour = ref(undefined)
const tempCrms = ref<string | undefined>(undefined)
const tempCrmsUf = ref<string | undefined>(undefined)

const stationTypes = ref([
  { title: 'Fixo', value: 'FIXO' },
  { title: 'Cobertura', value: 'COBERTURA' },
  { title: 'Extra', value: 'EXTRA' }
])
const stationOur = ref([
  { title: 'Sim', value: true },
  { title: 'Não', value: false }
])

const weekOfMonthOptions = ref([
  { title: 'Semana A', value: 0 },
  { title: 'Semana B', value: 1 },
  { title: 'Semana C', value: 2 },
  { title: 'Semana D', value: 3 },
  { title: 'Semana E', value: 4 }
])
const parityOptions = ref([
  { title: 'Par', value: 0 },
  { title: 'Ímpar', value: 1 }
])

const toast = useToast()

// M10-A: os chips só aparecem quando a última consulta já trouxe `coverageCounts`.
const stationStore = useStationStore()
// Só a Consulta liga (`showCoverageStatus`): "Aprovar plantões" usa este modal e continua como hoje.
const consultingCoverageCounts = computed(() =>
  props.showCoverageStatus ? (stationStore.consulting?.coverageCounts ?? null) : null
)
// Com os chips disponíveis, o toggle legado "Situação da Vaga" (Informações Principais) some: os
// dois juntos eram ambíguos. Um valor legado residual (URL/sessão) vira a seleção equivalente nos
// chips, para nada ficar filtrando escondido. `true` = só vaga aberta (c0f1172b); `false` = preenchida.
watch(
  consultingCoverageCounts,
  (available) => {
    if (!available) return
    const legacy = filterStates.isOpenDoctorStation
    if (legacy !== true && legacy !== false) return
    if (!filterStates.coverageStatus?.length) {
      filterStates.coverageStatus = legacy
        ? [CoverageStatus.OPEN]
        : [CoverageStatus.DOCTOR, CoverageStatus.UNIDENTIFIED]
    }
    filterStates.isOpenDoctorStation = null
  },
  { immediate: true }
)
const setCoverageStatus = (value: CoverageStatus[]) => {
  filterStates.coverageStatus = value.length ? value : null
  // D-B1: com chips, os filtros legados de vaga saem (os dois juntos fariam AND no BE).
  if (value.length) {
    filterStates.openedStation = null
    filterStates.isOpenDoctorStation = null
  }
}

const handleSubmit = async () => {
  if (!filterStates.startDate || !filterStates.endDate) {
    toast.warning('Selecione a data de início e fim antes de aplicar os filtros')
    return
  }

  isLoading.value = true
  // Tela sem chips (Aprovar plantões): nenhum coverageStatus residual viaja.
  if (!props.showCoverageStatus) filterStates.coverageStatus = undefined
  filterStates.startHour = undefined
  filterStates.endHour = undefined

  if (tempStartHour.value) {
    const val = String(tempStartHour.value)
    filterStates.startHour = val.includes(',')
      ? val
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      : [val]
  }

  if (tempEndHour.value) {
    const val = String(tempEndHour.value)
    filterStates.endHour = val.includes(',')
      ? val
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      : [val]
  }

  filterStates.crms = tempCrms.value
    ? tempCrms.value
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : undefined
  filterStates.crmStates = tempCrmsUf.value
    ? tempCrmsUf.value
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : undefined

  await useFilterStations.setFilters().finally(() => {
    isLoading.value = false
    handleToggleModal()
  })
}
const useFilterStations = useFilterStationsStore()

const handleClearFilters = async () => {
  handleToggleModal()
  await useFilterStations.clearFilters()
}

onUnmounted(() => {
  useFilterStations.clearFilters()
})

watch(
  () => modals.value[modalName],
  (isOpen) => {
    if (isOpen) loadOperationalGroups()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    "max-width": "!w-[80vw] !max-w-[960px]",
    "min-height": "90vh",
    "max-height": "90vh",
    class: "figma-custom-modal",
    "has-header-border": true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabConfig, (tab) => {
            return _createElementVNode("button", {
              key: tab.key,
              type: "button",
              "data-testid": `filter-tab-${tab.key}-button`,
              onClick: ($event: any) => (currentTab.value = tab.key),
              class: _normalizeClass(["flex items-center gap-2 md:gap-4 px-3 md:px-4 py-3 md:py-4 text-left transition-colors duration-200", 
            currentTab.value === tab.key
              ? 'bg-[#2F7F91] text-white font-bold'
              : 'text-[#16161D] hover:bg-[#E8E8EE]'
          ])
            }, [
              _createVNode(_component_v_icon, {
                size: "24",
                icon: tab.icon,
                color: currentTab.value === tab.key ? 'white' : '#16161D'
              }, null, 8, ["icon", "color"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(tab.label), 1)
            ], 10, _hoisted_4)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(currentTabLabel.value), 1),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(MultipleSchedules, {
                  company: _unref(filterStates).company,
                  "onUpdate:company": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterStates).company) = $event)),
                  healthUnits: _unref(filterStates).healthUnits,
                  "onUpdate:healthUnits": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterStates).healthUnits) = $event)),
                  schedules: _unref(filterStates).schedules,
                  "onUpdate:schedules": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filterStates).schedules) = $event)),
                  doctors: _unref(filterStates).doctors,
                  "onUpdate:doctors": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filterStates).doctors) = $event)),
                  positions: _unref(filterStates).positions,
                  "onUpdate:positions": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filterStates).positions) = $event)),
                  shifts: _unref(filterStates).shifts,
                  "onUpdate:shifts": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filterStates).shifts) = $event)),
                  isOpenDoctorStation: _unref(filterStates).isOpenDoctorStation,
                  "onUpdate:isOpenDoctorStation": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filterStates).isOpenDoctorStation) = $event)),
                  "hide-open-doctor-station": !!consultingCoverageCounts.value
                }, null, 8, ["company", "healthUnits", "schedules", "doctors", "positions", "shifts", "isOpenDoctorStation", "hide-open-doctor-station"])
              ]),
              _createVNode(_component_v_autocomplete, {
                modelValue: _unref(filterStates).operationalGroups,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filterStates).operationalGroups) = $event)),
                items: operationalGroupOptions.value,
                label: "Grupo Operacional",
                multiple: "",
                clearable: "",
                theme: "light",
                variant: "outlined",
                density: "compact",
                class: "w-full md:col-span-2",
                color: "primary20"
              }, null, 8, ["modelValue", "items"]),
              (_ctx.showSectorSpecialty)
                ? (_openBlock(), _createBlock(StationSectorSpecialtyFilters, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterStates).doctorName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(filterStates).doctorName) = $event)),
                class: "w-full md:col-span-2",
                label: "Nome do Médico",
                placeholder: "Buscar por nome...",
                clearable: "",
                color: "primary20",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: tempCrms.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((tempCrms).value = $event)),
                class: "w-full",
                label: "CRM (números)",
                placeholder: "Ex: 12345, 67890",
                clearable: "",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Números de CRM separados por vírgula"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: tempCrmsUf.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((tempCrmsUf).value = $event)),
                class: "w-full",
                label: "UF do CRM",
                placeholder: "Ex: SP, RJ",
                clearable: "",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Estados separados por vírgula"
              }, null, 8, ["modelValue"])
            ], 512), [
              [_vShow, currentTab.value === 'info']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(DatePicker), {
                modelValue: _unref(filterStates).startDate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(filterStates).startDate) = $event)),
                locale: "pt-BR",
                masks: { input: `DD/MM/YYYY` }
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    label: "Dia Inicial",
                    placeholder: "DD/MM/AAAA",
                    "prepend-inner-icon": _unref(mdiCalendar),
                    "model-value": inputValue
                  }, _toHandlers(inputEvents), {
                    density: "compact",
                    variant: "outlined",
                    class: "w-full",
                    color: "primary20"
                  }), null, 16, ["prepend-inner-icon", "model-value"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_unref(DatePicker), {
                modelValue: _unref(filterStates).endDate,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(filterStates).endDate) = $event)),
                locale: "pt-BR",
                masks: { input: `DD/MM/YYYY` }
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    label: "Dia Final",
                    placeholder: "DD/MM/AAAA",
                    "prepend-inner-icon": _unref(mdiCalendar),
                    "model-value": inputValue
                  }, _toHandlers(inputEvents), {
                    density: "compact",
                    variant: "outlined",
                    class: "w-full",
                    color: "primary20"
                  }), null, 16, ["prepend-inner-icon", "model-value"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: tempStartHour.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((tempStartHour).value = $event)),
                class: "w-full",
                type: "time",
                label: "Hora Início",
                color: "primary20",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: tempEndHour.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((tempEndHour).value = $event)),
                class: "w-full",
                type: "time",
                label: "Hora Fim",
                color: "primary20",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).weekDays,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(filterStates).weekDays) = $event)),
                multiple: "",
                class: "w-full md:col-span-2",
                color: "primary20",
                label: "Dias da semana",
                items: _unref(weekDays),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).weekOfMonth,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(filterStates).weekOfMonth) = $event)),
                items: weekOfMonthOptions.value,
                label: "Semana do Mês",
                multiple: "",
                class: "w-full",
                color: "primary20",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).stationWeekParity,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(filterStates).stationWeekParity) = $event)),
                items: parityOptions.value,
                label: "Paridade da Semana",
                hint: "Semana de domingo a sábado: o sábado e o domingo de um mesmo fim de semana ficam em paridades diferentes.",
                "persistent-hint": "",
                class: "w-full",
                color: "primary20",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"])
            ], 512), [
              [_vShow, currentTab.value === 'data']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterStates).valueMin,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(filterStates).valueMin) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor Mínimo (Vaga)",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor da vaga"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterStates).valueMax,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(filterStates).valueMax) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor Máximo",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor da vaga"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterStates).paymentValueMin,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(filterStates).paymentValueMin) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor aprovado mínimo",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor aprovado pelo hospital"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                class: "w-full",
                modelValue: _unref(filterStates).paymentValueMax,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(filterStates).paymentValueMax) = $event)),
                prefix: "R$",
                type: "number",
                label: "Valor aprovado máximo",
                color: "primary20",
                variant: "outlined",
                hint: "Valor aprovado pelo hospital",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).advanceRequested,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(filterStates).advanceRequested) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Antecipação Solicitada",
                items: [
                { title: 'Sim', value: true },
                { title: 'Não', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).advancePaid,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(filterStates).advancePaid) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Antecipação Paga",
                items: [
                { title: 'Sim', value: true },
                { title: 'Não', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).inCash,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(filterStates).inCash) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Pagamento á vista",
                items: [
                { title: 'Sim', value: true },
                { title: 'Não', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ], 512), [
              [_vShow, currentTab.value === 'valores']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              (consultingCoverageCounts.value)
                ? (_openBlock(), _createBlock(CoverageStatusFilterChips, {
                    key: 0,
                    class: "w-full md:col-span-2",
                    "model-value": _unref(filterStates).coverageStatus ?? [],
                    counts: consultingCoverageCounts.value,
                    "onUpdate:modelValue": setCoverageStatus
                  }, null, 8, ["model-value", "counts"]))
                : _createCommentVNode("", true),
              (!consultingCoverageCounts.value)
                ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                    key: 1,
                    clearable: "",
                    modelValue: _unref(filterStates).openedStation,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(filterStates).openedStation) = $event)),
                    class: "w-full",
                    color: "primary20",
                    label: "Vaga do plantão",
                    items: [
                { title: 'Não preenchida', value: true },
                { title: 'Preenchida', value: false }
              ],
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).status,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(filterStates).status) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Status do plantão",
                items: [
                { title: 'Pendente', value: 'waiting' },
                { title: 'Confirmado', value: 'confirmed' }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).stationType,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(filterStates).stationType) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Periodicidade",
                items: stationTypes.value,
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).ourTeam,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(filterStates).ourTeam) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Nosso plantão?",
                items: stationOur.value,
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).doctorStatus,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(filterStates).doctorStatus) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Médico confirmou?",
                items: [
                { title: 'Confirmado', value: true },
                { title: 'Não confirmado', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).hasException,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(filterStates).hasException) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Excepcionalidade",
                items: [
                { title: 'Com excepcionalidade', value: true },
                { title: 'Sem excepcionalidade', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).withCheckin,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(filterStates).withCheckin) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Checkin",
                items: [
                { title: 'Com checkin', value: true },
                { title: 'Sem checkin', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_autocomplete, {
                clearable: "",
                modelValue: _unref(filterStates).withCheckout,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(filterStates).withCheckout) = $event)),
                class: "w-full",
                color: "primary20",
                label: "Checkout",
                items: [
                { title: 'Com checkout', value: true },
                { title: 'Sem checkout', value: false }
              ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ], 512), [
              [_vShow, currentTab.value === 'status']
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(GhostButton, {
                class: "flex-1",
                "data-testid": "filter-clear-button",
                onClick: handleClearFilters,
                width: "100%",
                text: "Limpar filtros"
              }),
              _createVNode(FilledButton, {
                class: "flex-1",
                "data-testid": "filter-apply-button",
                loading: isLoading.value,
                onClick: handleSubmit,
                text: "Aplicar Filtros",
                height: "48px",
                width: "100%"
              }, null, 8, ["loading"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})